import React from 'react';
import BaseHeader from './BaseHeader';
import { Image } from 'react-native';
import Images from '../../../Images';
import { NativeStackHeaderProps } from '@react-navigation/native-stack';

export type LogoHeaderOwnProps = {};

export type LogoHeaderProps = LogoHeaderOwnProps & NativeStackHeaderProps;

const LogoHeader: React.FC<LogoHeaderProps> = (props) => {
    return (
        <BaseHeader
            {...props}
            height={60}
            centerContent={
                <Image
                    alt="primary record logo"
                    style={{ width: 187, height: 25 }}
                    resizeMode="contain"
                    source={Images.PrimaryRecordLogoDarkV2}
                    defaultSource={Images.PrimaryRecordLogoDarkV2}
                />
            }
        />
    );
};

export default React.memo(LogoHeader);
